import React from "react";
import moment from "moment";
import {
  StyleSheet,
  View,
  ScrollView,
  Platform,
  KeyboardAvoidingView,
} from "react-native";

import { isAndroid } from "../../../../helpers/utils";

import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import Header from "../../common/header";
import MessageCard from "./MessageCard";
import Search from "../../common/search-bar/Search";
import Footer from "../../common/footer/bar";

const DATETIME_FORMAT = "h:mm,  MM/DD/YY";

export default class CoachingRoomPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    const username =
      this.controller.state?.impersonate || this.controller.state?.currentUser;
    const userAvatar = props.controller.state?.picture;

    this.state = {
      username,
      userAvatar,
      messages: [
        {
          username: "Mari",
          avatar: null,
          time: moment().format(DATETIME_FORMAT),
          message: `Hi ${username}, welcome! I'm Mari, your personal time coach. I'm excited to offer personalized insights based on your unique work experiences, so please don't hesitate to ask me any questions you have about using time better, developing professionally, or finding work-life balance.`,
        },
      ],
    };
  }

  getCurrentTime = () => {
    return moment().format(DATETIME_FORMAT);
  };

  goBack = () => {
    this.controller.goBack();
  };

  askMari = ({ term }) => {
    const { messages, username, userAvatar } = this.state;

    this.setState((state) => ({
      ...state,
      isLoading: true,
      messages: [
        ...messages,
        {
          username,
          avatar: userAvatar,
          time: this.getCurrentTime(),
          message: term,
        },
      ],
    }));

    const action = {
      action: "ask-mari",
      message: term,
    };

    this.controller.apiService.cardAction(action).then((r) => {
      try {
        const { messages } = this.state;

        const reply = JSON.parse(r);
        console.log(reply.message);
        this.setState((state) => ({
          ...state,
          isLoading: false,
          term: "",
          messages: [
            ...messages,
            {
              username: "Mari",
              avatar: null,
              time: this.getCurrentTime(),
              message: reply.message,
            },
          ],
        }));
        this.scrollView.scrollToEnd();
      } catch (e) {
        console.log(e);
      }
    });
  };

  render() {
    const { isLoading, messages } = this.state;

    return (
      <View style={appStyles.container}>
        <KeyboardAvoidingView
          style={appStyles.kbViewNoFooter}
          keyboardVerticalOffset={isAndroid ? 70 : 0}
          behavior="height"
        >
          <Header
            title="Mari's Coaching Room"
            subTitle="Personalized Prof. Dev. Coaching"
            goBack={this.goBack}
            isLoading={isLoading}
            hideAvatar
          />

          <ScrollView
            ref={(ref) => {
              this.scrollView = ref;
            }}
            contentContainerStyle={appStyles.scrollViewContent}
            style={[
              appStyles.scrollView,
              {
                backgroundColor: AppTheme.containerBg,
                paddingHorizontal: 8,
                paddingTop: 8,
                marginTop: 0,
              },
            ]}
          >
            {messages.map((message, index) => (
              <MessageCard key={index} {...message} />
            ))}
          </ScrollView>

          <View style={styles.footerOptions}>
            <Search
              isChatSearch
              controller={this.controller}
              filterResults={this.askMari}
              placeholder="Start Typing..."
              showIcon={false}
              inputStyle={styles.searchInputStyle}
            />
          </View>
        </KeyboardAvoidingView>

       {/*  <View style={appStyles.footerOptions}>
          <Footer
            controller={this.controller}
            navigation={{ navigate: this.controller.navigate }}
          />
        </View> */}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  footerOptions: {
    ...appStyles.footerOptions,
    paddingTop: 4,
    paddingBottom: 31,
    //paddingBottom: 4,
    //marginBottom: 11,
    paddingHorizontal: 8,
    backgroundColor: "rgba(000, 000, 000, 0.3)",
  },

  searchInputStyle: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
});
